import { useConsultationContext } from "dsl/ecosystems/Consultation/ConsultationLayout";

export default function ConsultationFiles() {
  const { consultation, patient } = useConsultationContext();

  return (
    <>
      {/* TODO: To be implemented: Files tab */}
      <h2 className="text-xl font-semibold">
        Files – Consultation {consultation.id}
      </h2>
      {patient?.id != null && (
        <p className="mt-2 text-sm text-gray-600">
          Patient: {patient.user_id ?? patient.id}
        </p>
      )}
    </>
  );
}
